import { createAction } from '@reduxjs/toolkit';

export const SUBMIT_WITHDRAW = 'SUBMIT_WITHDRAW';
export const SUCCESS_WITHDRAW = 'SUCCESS_WITHDRAW';
export const FAILED_WITHDRAW = 'FAILED_WITHDRAW';
export const RESET_WITHDRAW_STATE = 'RESET_WITHDRAW_STATE';
export const RESET_WITHDRAW_ERROR_STATE = 'RESET_WITHDRAW_ERROR_STATE';
export const GET_WITHDRAW_FEE = 'GET_WITHDRAW_FEE';
export const SET_WITHDRAW_FEE = 'SET_WITHDRAW_FEE';

export interface ISubmitWithdrawPayload {
    bankCode: string,
    accountName: string,
    accountNumber: string,
    password: string,
    reason: string,
    amount: number,
    methodPayment: number
}

/* eslint-disable camelcase */
export interface GetWithdrawFeePayload {
    bankCode: string,
    amount: number,
    payment_method: number
}

/* eslint-disable camelcase */
export interface GetWithdrawFeeResponse {
    transfer_fee: number,
    transfer_type: string
}

export interface IFailedWithdrawResponse {
    error: string;
    message: string;
}

export const submitWithdrawAction =
    createAction<ISubmitWithdrawPayload>(SUBMIT_WITHDRAW);
export const successWithdrawAction =
    createAction<string>(SUCCESS_WITHDRAW);
export const failedWithdrawAction =
    createAction<IFailedWithdrawResponse>(FAILED_WITHDRAW);
export const resetWithdrawStateAction =
    createAction<boolean>(RESET_WITHDRAW_STATE);
export const resetWithdrawErrorStateAction =
    createAction<string>(RESET_WITHDRAW_ERROR_STATE);
export const getWithdrawFeeAction =
    createAction<GetWithdrawFeePayload>(GET_WITHDRAW_FEE);
export const setWithdrawFee =
    createAction<GetWithdrawFeeResponse>(
        SET_WITHDRAW_FEE
    );
